<template>
  <div>
    <section>
      <el-row>
        <el-col :span="2">
             <img class="avatar" :src="avatar?avatar:require('../../assets/avatar.png')"  min-width="100" height="100" />
        </el-col>
        <el-col :span="4">
            <el-col :span="24" style="margin-top: 10px;">
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                    <span style="font-size: 25px;">{{ userName }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 16px;color: #848181;">用户ID:</span>
                    <span style="font-size: 16px;color: #848181;">{{ userId }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
        <el-col :span="16" style="height:1px">

        </el-col>
        <el-col :span="2">
            <el-col :span="24" style="margin-top: 10px;">
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                     <span style="font-size: 16px;color: #848181;">累计金额</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 28px;">{{ totalAmount }}元</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
      </el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true">
          <el-form-item class="form-class">
            <el-select multiple v-model="values" placeholder="请选择" @change="verifyChanged">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-class">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="changeTime"
              v-model="timeInterval"
              type="datetimerange"
              range-separator="至"
              :start-placeholder=create_start_date
              :end-placeholder=create_end_date>
            </el-date-picker>
            <i class="el-icon-date icon-class"></i>
          </el-form-item>
          <el-form-item class="form-class">
            <el-button type="primary" @click="getUserDetailsForCondition">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table stripe align="left" :data="tableDate" highlight-current-row v-loading="listLoading"
                style="width: 100%;">
        <el-table-column type="index" align="center" prop="id" label="序号" min-width="10%">
        </el-table-column>
        <el-table-column align="center" prop="des" label="类型" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="amount" label="金额" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="phone" label="手机号" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="createTime" label="记账时间" :formatter="formatTime"
                         min-width="40%"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page=currentPage
        :page-sizes="[10, 20, 30, 40]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </section>
  </div>
</template>

<script>
  import {Options} from './detail-data.js'

  export default {
    name: "details",
    data() {
      return {
        values: [],
        options: Options.data,
        create_end_date: '结束日期',
        create_start_date: '开始日期',
        tableDate: null,
        listLoading: false,
        totalAmount: 0,
        userId: null,
        userName: '',
        avatar:null,
        currentPage: 0,
        pageSize: 10,
        total: 0,
        timeInterval: '',
      }
    },
    methods: {
      getMoney(param) {
        this.$http.post(this, '/userDetail/getMoney', {}, param).then(res => {
          if (res.code == 200) {
            if (res.data == null) {
              this.totalAmount = 0
            } else {
              this.totalAmount = res.data
            }
          } else {
            this.totalAmount = 0
          }
        })
      },
      formatTime(row, column) {
        if (!row.createTime) {
          return '';
        }
        return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getUserDetailsForCondition()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getUserDetailsForCondition()
      },
      getUserDetailsForCondition() {
        let param = {};
        param['userId'] = this.userId
        param['types'] = this.values.length == 0 ? [] : this.values
        param['startTime'] = this.create_start_date == '开始日期' ? '' : this.create_start_date
        param['endTime'] = this.create_end_date == '结束日期' ? '' : this.create_end_date
        this.$http.post(this, '/userDetail/detailsCondition',
          {
            currentPage: this.currentPage == 0 ? this.currentPage : this.currentPage - 1,
            pageSize: this.pageSize
          }, param).then(res => {
          this.listLoading = false
          this.tableDate = res.data.data
          this.total = res.data.count
          this.pageSize = res.data.size
        })
        this.getMoney(param)
      },
      changeTime() {
        if (this.values.indexOf('所有入账', 0) != -1 || this.values.indexOf('所有出账', 0) != -1) {
          this.timeInterval = null
          let type = ''
          if (this.values.indexOf('所有入账', 0) != -1) {
            type = '所有入账'
          } else if (this.values.indexOf('所有出账', 0) != -1) {
            type = '所有出账'
          }
          this.$message({
            message: '您已选择"' + type + '",无法选择时间！',
            type: "error"
          })
        }
        this.create_start_date = this.timeInterval == null ? '开始日期' : this.timeInterval[0]
        this.create_end_date = this.timeInterval == null ? '结束日期' : this.timeInterval[1]
      },
      verifyChanged() {
        if (this.values != null) {
          if (this.values.indexOf('所有出账', 0) != -1 && this.values.indexOf('所有入账', 0) != -1) {
            this.$message({
              message: '所有入账和所有出账只能选择一个!',
              type: 'error'
            });
            this.values = []
          } else if (this.values.indexOf('所有出账', 0) != -1 || this.values.indexOf('所有入账', 0) != -1) {
            if (this.values.indexOf('所有出账', 0) != -1) {
              this.values = []
              this.values[0] = '所有出账'
            } else if (this.values.indexOf('所有入账', 0) != -1) {
              this.values = []
              this.values[0] = '所有入账'
            }
            if (this.timeInterval != null) {
              this.timeInterval = null
              this.$message({
                message: '您已选择"' + this.values[0] + '",无法选择时间！',
                type: "error"
              })
            }
            this.create_start_date = '开始日期'
            this.create_end_date = '结束日期'
          }

          if (this.values.indexOf('转发') != -1) {
            if (this.values.indexOf('转发佣金') == -1) {
              this.values.push('转发佣金')
            }
          } else {
            if (this.values.indexOf('转发佣金') != -1) {
              let index = this.values.indexOf('转发佣金')
              this.values.splice(index, 1)
            }
          }

          if (this.values.indexOf('推页红包') != -1) {
            if (this.values.indexOf('打开红包') == -1) {
              this.values.push('打开红包')
            }
          } else {
            if (this.values.indexOf('打开红包') != -1) {
              let index = this.values.indexOf('打开红包')
              this.values.splice(index, 1)
            }
          }

          if (this.values.indexOf('充值（后台）') != -1) {
            if (this.values.indexOf('管理员充值') == -1) {
              this.values.push('管理员充值')
            }
          } else {
            if (this.values.indexOf('管理员充值') != -1) {
              let index = this.values.indexOf('管理员充值')
              this.values.splice(index, 1)
            }
          }
        }
        console.log(this.values);
      }
    },
    created() {
      this.userId = this.$route.query.userId
      this.userName = this.$route.query.userName
      this.avatar = this.$route.query.avatar
      this.listLoading = true
      this.getUserDetailsForCondition();
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;

  .el-form-item {
    margin-bottom: 10px;
    width: 20%;
  }

  }

  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
</style>
